"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_router_dom_1 = require("react-router-dom");
var Card_1 = __importDefault(require("../../../../common/Card/Card"));
var HeaderBar_1 = __importDefault(require("../../../../theme/headerbar/HeaderBar"));
var Report = function () {
    var push = (0, react_router_dom_1.useHistory)().push;
    return (react_1.default.createElement(HeaderBar_1.default, { title: "report", hideSave: true },
        react_1.default.createElement("div", { style: { flexDirection: "row", display: "flex" } },
            react_1.default.createElement(Card_1.default, { text: "General", icon: "setting", onClick: function () {
                    push("/admin/General");
                } }),
            react_1.default.createElement(Card_1.default, { text: "Disease", icon: "education_report", onClick: function () {
                    push("/admin/General");
                } }))));
};
exports.default = Report;
